<template>
    <div>
        电子科技大学
    </div>
</template>

<script>

</script>

<style scoped>

</style>